<template>
  <div class="news-detail">
    <div class="news-detail-title">{{data.title}}</div>
    <div class="news-detail-time">{{data.create_time}}</div>
    <div class="news-detail-content" v-html="data.content"></div>
  </div>
</template>
<script>
import { formatCreateTime } from '@/utils/dateFormat'
import { applyPageMeta, setArticleJsonLd } from '@/utils/pageMeta'
import { signalPrerenderReady } from '@/utils/prerender'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    this.getDetail(this.$route.params.id || this.$route.query.id);
  },
  watch: {
    '$route.params.id'(id) {
      this.getDetail(id)
    }
  },
  methods: {
    // 拉取新闻正文，写入标题和 Article 结构化数据后再允许预渲染
    getDetail(id) {
      if (!id) {
        signalPrerenderReady()
        return
      }
      this.axios.get(this.$rootUrl + "/unidt/get_article" + "?id=" + id).then((res) => {
        const { code, data } = res.data;
        if (code === 0 && data) {
          this.data = formatCreateTime({ ...data })
          applyPageMeta({
            title: this.data.title + '-华院新闻',
            description: this.data.content || this.data.title,
            path: '/news/' + id
          })
          setArticleJsonLd(this.data, id)
        }
        this.$nextTick(() => signalPrerenderReady())
      })
      .catch(function(error) {
        console.log(error);
        signalPrerenderReady()
      });
    },
  }
}
</script>
<style lang="less" scoped>
.news-detail {
  padding: 96px 64px;
  .news-detail-title {
    font-size: 36px;
    color: #08204D;
    line-height: 56px;
    margin-top: 42px;
    text-align: center;
  }
  .news-detail-time{
    font-size: 24px;
    font-weight: 400;
    color: #97A2B5;
    line-height: 36px;
    margin-top: 24px;
    text-align: center;
  }
  .news-detail-content {
    font-size: 24px;
    font-weight: 400;
    color: #08204D;
    line-height: 40px;
    margin-top: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/news/detail.vue